import React, {Component} from 'react'
import { Row, Col, FormControl, Modal, Form, FormGroup, Button } from 'react-bootstrap'
import { Checkbox, Radio } from 'react-icheck'
import PrintPreview from '../PrintPreview'
import FontAwsome from 'react-fontawesome'
import WorkdocStore from 'stores/WorkdocStore'
import PdfStore from 'stores/PdfStore'
import TextFieldModal from 'component/element/TextFieldModal'

var NotificationSystem = require('react-notification-system');
const REPAIR_ORDERS = [
  {title:{t:'ลอกสีพร้อมพ่นสีทั้งคัน',t1:'สาดสีทั้งคัน',t2:false},status:{s:false,s1:false,s2:false}},
  {title:{t:'พ่นสีทั้งคัน/หลังคา',t1:'ขัดสีทั้งคัน',t2:'หน้ากระจก'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีกันชน',t1:'หน้า',t2:'หลัง'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีสเกิตกันชน',t1:'หน้า',t2:'หลัง'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีฝากระโปรง',t1:'หน้า',t2:'หลัง'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีประตูหน้า',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีประตูหลัง/แค๊ป',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีบันได/สเกิตข้าง',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีกระบะ',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีบังโคลนหน้า',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'เคาะ พ่นสีบังโคลนหลัง',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}}
]
const REPLACEMENT_ORDERS = [
  {title:{t:'กันชน/กระจก',t1:'หน้า',t2:'หลัง'},status:{s:false,s1:false,s2:false}},
  {title:{t:'สเกิตกันชน',t1:'หน้า',t2:'หลัง'},status:{s:false,s1:false,s2:false}},
  {title:{t:'สเกิตข้าง/บันได้เสริม',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'กันชนเสริม',t1:'หน้า',t2:'หลัง'},status:{s:false,s1:false,s2:false}},
  {title:{t:'กระจกมองข้าง',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'ไฟหน้า',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'ไฟตัดหมอก',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'กระจกประตูหน้า/หลัง',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'บังโคลนหน้า/หลัง',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'ฝากระโปรง',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'ประตูหน้า/หลัง',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}},
  {title:{t:'ไฟท้าย',t1:'ซ้าย',t2:'ขวา'},status:{s:false,s1:false,s2:false}}
]
class PrintWCSParkingCarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:[],related_detail_wcs:{repair_orders:{other:'',ordersList:[]},replacement_orders:{other:'',ordersList:[]}},page_title:'กำลังดึงข้อมูล..'}
    
    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
    this.loadAnyParkingcarDoc()
  }

  loadAnyParkingcarDoc() {
    let {workNo} = this.props
    let {data,related_detail_wcs} = this.state
    PdfStore.loadAnyParkingcarDoc(workNo,'wcs_parking_doc',(result)=>{
      
      if (result.data.related_detail===undefined||result.data.related_detail.repair_orders===undefined||result.data.related_detail.replacement_orders
===undefined) {
        related_detail_wcs.repair_orders.ordersList = REPAIR_ORDERS
        related_detail_wcs.replacement_orders.ordersList = REPLACEMENT_ORDERS
      } else {
        related_detail_wcs = result.data.related_detail
      }

      this.setState({data:result.data,page_title:'ไม่พบข้อมูล',related_detail_wcs:related_detail_wcs})  
    }) 
  }

  renderLogoUrl(logo){
    let logoWidth = logo.logo_width
    let logoUrl = logo.logo_url
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    if(logoUrl!==undefined)
      return (<img src={imgUrl} style={{width:logoWidth+'px'}}/>)
    else
      return ('')
  }

  onCheckChange(key,index,sub_key,value,e) {
    let {related_detail_wcs} = this.state

    if (sub_key=='s')
      related_detail_wcs[key].ordersList[index].status.s = value===false ? true : false
    else if (sub_key=='s1')
      related_detail_wcs[key].ordersList[index].status.s1 = value===false ? true : false
    else if (sub_key=='s2')
      related_detail_wcs[key].ordersList[index].status.s2 = value===false ? true : false

    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveWCSParkingCarDoc()
  }

  onOtherSave(fieldInfo) {
    let {related_detail_wcs} = this.state
    let note = fieldInfo.value === undefined ? '' : fieldInfo.value
    related_detail_wcs[fieldInfo.key].other = note
    this.setState({related_detail_wcs:related_detail_wcs})
    this.saveWCSParkingCarDoc()
  }

  saveWCSParkingCarDoc() {
    let {workNo} = this.props
    let {related_detail_wcs} = this.state
    WorkdocStore.saveWorkdocRelated(workNo,'wcs_parking_doc',related_detail_wcs,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  renderRowDataCheck(items,key) {
    return(
      items.ordersList.map((item,index) => {
        return(
          <tr key={index}>
            <td className='br-h'>
              <Checkbox
                onChange={this.onCheckChange.bind(this,key,index,'s',item.status.s)}
                checked={item.status.s}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ' + item.title.t}
              >
              </Checkbox>
            </td>
            <td className='br-h'>
              <Checkbox
                onChange={this.onCheckChange.bind(this,key,index,'s1',item.status.s1)}
                checked={item.status.s1}
                checkboxClass="icheckbox_minimal"
                increaseArea="20%"
                label={' ' + item.title.t1}
              >
              </Checkbox>
            </td>
            <td className=''>
              { 
                item.title.t2===false ? '' :
                <Checkbox
                  onChange={this.onCheckChange.bind(this,key,index,'s2',item.status.s2)}
                  checked={item.status.s2}
                  checkboxClass="icheckbox_minimal"
                  increaseArea="20%"
                  label={' ' + item.title.t2}
                >
                </Checkbox>
              }
            </td>
          </tr>
        )
      })
    )
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onOtherClick(key,value,e) {
    let fieldInfo = {title:'อื่นๆ',showClear:false,value:value,key:key}
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  renderCheck() {
    let {data,related_detail_wcs} = this.state
    const {showPrice} = this.props
    return(
      <div style={{width:'100%'}}>
        <div style={{width:'50%',float:'left',paddingRight:'10px'}}>
          <table className='table table-print-wcs-parking-car-check'>
            <tbody>
              <tr>
                <td colSpan={3} className='text-center'>รายการสั่งซ่อม</td>
              </tr>
              {this.renderRowDataCheck(related_detail_wcs.repair_orders,'repair_orders')}
              <tr>
                <td onClick={this.onOtherClick.bind(this,'repair_orders',related_detail_wcs.repair_orders.other)} colSpan={3} className=''>อื่นๆ {related_detail_wcs.repair_orders.other}</td>
              </tr>
              <tr>
                <td colSpan={3} className='bt-h'><br/></td>
              </tr>
            </tbody>
          </table>
          <table className='table table-print-wcs-parking-car-doc' style={{display:(showPrice?'':'none')}}>
            <tbody>
              <tr>
                <td>ค่าขัดสี</td>
                <td className='text-center'></td>
                <td className='text-right'>บาท</td>
              </tr>
              <tr>
                <td>ค่าใช้จ่ายอื่น</td>
                <td className='text-center'></td>
                <td className='text-right'>บาท</td>
              </tr>
              <tr>
                <td>ค่าส่วนรวมจ่าย</td>
                <td className='text-center'></td>
                <td className='text-right'>บาท</td>
              </tr>
              <tr>
                <td>รวมทั้งสิ้น</td>
                <td className='text-center'>{data.amount!==undefined?this.getNumberFormat(data.amount):'0.00'}</td>
                <td className='text-right'>บาท</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style={{width:'50%',float:'right',paddingLeft:'10px'}}>
          <table className='table table-print-wcs-parking-car-check'>
            <tbody>
              <tr>
                <td colSpan={3} className='text-center'>รายการสั่งเปลี่ยนอะไหล่</td>
              </tr>
              {this.renderRowDataCheck(related_detail_wcs.replacement_orders,'replacement_orders')}
              <tr>
                <td onClick={this.onOtherClick.bind(this,'replacement_orders',related_detail_wcs.replacement_orders.other)} colSpan={3} className=''>อื่นๆ {related_detail_wcs.replacement_orders.other}</td>
              </tr>
            </tbody>
          </table>
          <table className='table table-print-wcs-parking-car-doc'>
            <tbody>
              <tr>
                <td>หมายเหตุ</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  renderSignature() {
    return(
        <div>
          <table className='table table-print-wcs-parking-car-doc'>
            <tbody>
              <tr>
                <td style={{width:'16.67%'}}>ผู้สั่งซ่อม</td>
                <td style={{width:'16.67%'}}></td>
                <td style={{width:'16.67%'}}>ผู้รับรถเข้าซ่อม</td>
                <td style={{width:'16.67%'}}></td>
                <td style={{width:'16.67%'}}>ผู้รับรถออก</td>
                <td style={{width:'16.67%'}}></td>
              </tr>
            </tbody>
          </table>
          <table className='table table-print-wcs-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-center' style={{width:'33.33%'}}>(......................................)</td>
                <td className='text-center' style={{width:'33.33%'}}>(......................................)</td>
                <td className='text-center' style={{width:'33.33%'}}>(......................................)</td>
              </tr>
            </tbody>
          </table>
        </div>  
    )
  }

  renderFooter() {
    return(
      <div className=''>
        โปรดอย่าทิ้งของมีค่าไว้ในรถ หากสูญหาย บริษัทฯ จะไม่รับผิดชอบ<br/>
        กรุณาตรวจสภาพรถให้เรียบร้อยก่อนนำรถออกจากอู่ มิฉะนั้นบริษัทฯจะไม่รับผิดชอบ
      </div>
    )
  }

  renderBody() {
    let {data} = this.state
    return(
      <div>
        <table className='table table-print-wcs-parking-car-doc'>
          <tbody>
            <tr>
              <td style={{width:'50%'}} colSpan={2}>วันที่นำรถเข้าซ่อม {data.receiving!==undefined?data.receiving.contact_date:''}</td>
              <td style={{width:'50%'}} colSpan={2}>วันที่ส่งมอบรถ {data.receiving!==undefined?data.receiving.appointment_date:''}</td>
            </tr>
            <tr>
              <td style={{width:'50%'}} colSpan={2}>ชื่อ {data.owner!==undefined?data.owner.name:''}</td>
              <td style={{width:'50%'}} colSpan={2}>ลำดับเรื่อง {data.receiving!==undefined?data.receiving.ref_no:''}</td>
            </tr>
            <tr>
              <td>เลขทะเบียน {data.car!==undefined?data.car.car_registration_no:''}</td>
              <td>ยี่ห้อ {data.car!==undefined?data.car.brand:''}</td>
              <td>รุ่น {data.car!==undefined?data.car.model:''}</td>
              <td style={{width:'20%'}}>สีรถ {data.car!==undefined?data.car.car_color:''}</td>
            </tr>
          </tbody>
        </table>
        {this.renderCheck()}
        <div className='footer-page'>
          {this.renderSignature()}
          {this.renderFooter()}
        </div>
      </div>
    )
  }

  renderComponentPage() {
    let {data} = this.state
    return(
      <div className='font-print'>
        <header>
          <h2 className="text-right">{this.props.title}</h2>
        </header>  
        <article className={"article-company "+data.logo_class}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data)}
          </div>
          <section className="font-18" style={{marginLeft:'10px',paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} (สำนักงานใหญ่)</p>           
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>เลขประจำตัวผู้เสียภาษีอากร {data.company_tax} โทร {data.company_tel}</p>              
            </strong>
          </section>
        </article>
        {this.renderBody()}
      </div>  
    )
  }

  render() {
    let {loading} = this.state
    return(
      <div>
        <PrintPreview 
            loading={loading}
            leftBarTitle={this.props.title}
          >
            {this.renderComponentPage()}
        </PrintPreview>
        <TextFieldModal 
          ref='textFieldModal'
          confirmTitle='บันทึก'
          onConfirm={this.onOtherSave.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>
    ) 
  }
}  

PrintWCSParkingCarDoc.defaultProps = {
  title: 'ใบสั่งซ่อม และใบรับรถ',  
  mode : '1',
  showPrice : true,
}
export default PrintWCSParkingCarDoc;


// WEBPACK FOOTER //
// ./src/view/print/wcs/PrintWCSParkingCarDoc.js